import styled from 'styled-components';
import { Button } from '../../../Button/Button';

export const StyledFmButton = styled(Button)(({ theme }) => ({
  fontSize: theme.fontSizes.small,
  lineHeight: theme.lineHeights.small,
  border: `1px solid ${theme.colors.neutral[300]}`,
  boxShadow: 'none',
  borderRadius: theme.radii.full,
  height: 'auto',
  padding: `${theme.space[8]}px ${theme.space[16]}px`,

  '&:not(.disabled):hover': {
    color: theme.colors.white,
    backgroundColor: theme.colors.primary['500'],
    borderColor: theme.colors.primary['500'],
  },
}));
